import { Dispatch, SetStateAction } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Stack, Link } from '@mui/material';
import { TextField } from '@mui/material';
import { Typography } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { toast } from 'react-toastify';
import { useFormik } from 'formik';
import { createResetPassword } from '../../store/users/api';
import { useAppDispatch } from '../../store';
import { Values } from '.';
import { resetEmail } from '../../validation/resetPasswordSchema';

type Props = {
  setSteps: (val: number) => void;
  state: Values;
  setValues: Dispatch<SetStateAction<Values>>;
};

const Index: React.FC<Props> = ({ setSteps, state, setValues }) => {
  const dispatch = useAppDispatch();

  const {
    handleSubmit,
    getFieldProps,
    resetForm,
    isSubmitting,
    errors,
    touched,
  } = useFormik({
    initialValues: state,
    validationSchema: resetEmail,
    onSubmit: async (values) => {
      try {
        const response = await dispatch(
          createResetPassword(values.email)
        ).unwrap();
        toast.success(response?.message);
        setValues((prevValue) => ({ ...prevValue, email: values.email }));
        resetForm();
        setSteps(2);
      } catch (error: any) {}
    },
  });

  return (
    <form
      autoComplete='off'
      noValidate
      onSubmit={handleSubmit}
    >
      <Stack spacing={3}>
        <TextField
          fullWidth
          autoComplete='username'
          type='email'
          label='Email address'
          {...getFieldProps('email')}
          error={Boolean(touched.email && errors.email)}
          helperText={touched.email && errors.email}
        />
      </Stack>

      <Stack
        direction='row'
        alignItems='center'
        justifyContent='space-between'
        sx={{ my: 1 }}
      ></Stack>
      <Stack
        direction='row'
        alignItems='center'
        justifyContent='center'
      >
        <LoadingButton
          fullWidth
          size='large'
          type='submit'
          variant='contained'
          loading={isSubmitting}
        >
          Get OTP
        </LoadingButton>
      </Stack>
      <Typography
        variant='body2'
        align='center'
        sx={{
          mt: 3,
        }}
      >
        Back to&nbsp;
        <Link
          variant='subtitle2'
          component={RouterLink}
          to={localStorage.getItem('resetPasswordFromCompanyLogin') === 'true' ? '/company-login' : '/login'}
          underline='hover'
        >
          Login
        </Link>
      </Typography>
    </form>
  );
};

export default Index;
